import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import CONFIG from "@/assets/js/config.js";
import "vue-loading-overlay/dist/vue-loading.css";
import { required, maxLength } from "vuelidate/lib/validators";
import store from "@/store";
import upLoad from '@/assets/img/upload_photo3.jpg';
import pdfIcon from '@/assets/img/pdf-icon.png';
import docIcon from '@/assets/img/doc-icon.png';

export default {
  name: "CourseCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading,
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_EXIST,
      assignmentData: {},
      updateAssignmentData: {
        acd_year_id: null,
        class_id: null,
        teacher_id: null,
        subject_id: null,
        title: '',
        description: '',
        from_date: '',
        to_date: '',
        img_paths: [],
      },
      classArr: [],
      academicYearArr: [],
      subjectArr: [],
      teacherArr: [],
      isLoading: false,
      submitted: false,
      disabled: false,
      upLoad,
      pdfIcon,
      docIcon,
      images: [],
      existingImages: [],
      noClassMsg: '',
      hasAnswer: false,
    };
  },

  validations() {
    const afterOrEqual = (value) => {
      if (!value || !this.assignmentData.from_date) return true
      return new Date(value) >= new Date(this.assignmentData.from_date)
    }

    return {
      assignmentData: {
        acd_year_id: {
          required
        },
        class_id: {
          required
        },
        teacher_id: {
          required
        },
        subject_id: {
          required
        },
        title: {
          required,
          maxLength: maxLength(255)
        },
        description: {
          maxLength: maxLength(5000)
        },
        from_date: {
          required
        },
        to_date: {
          required,
          afterOrEqual,
        }
      }
    }
  },

  computed: {
    allowedExtension() {
      return CONFIG.ASSIGNMENT.ALLOWED_EXTENSION;
    },
    normalizedExistingImages() {
      return this.existingImages.map(img => {
        const ext = img.file_name.split('.').pop().toLowerCase();
        return {
          ...img,
          ext,
          isImage: ['jpg','jpeg','png'].includes(ext),
          isPdf: ext === 'pdf'
        }
      })
    }
  },

  methods: {
    chooseFiles(id) {
      document.getElementById(id).click();
    },

    onFileChange(e) {
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        let file = selectedFiles[i];

        if (!CONFIG.ASSIGNMENT.ALLOWED_FILE_TYPES.includes(file.type)) {
          this.$notification.error(CONFIG.ASSIGNMENT.FILE_TYPE_ERROR, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }
        if (selectedFiles[i].size > CONFIG.ASSIGNMENT.MAX_FILE_SIZE) {
          this.$notification.error(CONFIG.ASSIGNMENT.MAX_FILE_SIZE_ERROR, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }
        let total_img_count = this.images.length + this.existingImages.length;
        if (total_img_count >= CONFIG.ASSIGNMENT.MAX_FILE_COUNT) {
          this.$notification.error(CONFIG.ASSIGNMENT.MAX_FILE_COUNT_ERROR, {
            timer: 3,
            position: "bottomCenter",
          });
        } else {
          this.images.push(selectedFiles[i]);
          for (let i = 0; i < this.images.length; i++) {
            let reader = new FileReader();
            reader.addEventListener('load', ((index) => {
              return () => {
                let refName = this.images[index].name;
                if (this.$refs[refName] && this.$refs[refName][0]) {
                  this.$refs[refName][0].src = reader.result;
                }
                this.images[index].data = reader.result;
              };
            })(i), false);

            reader.readAsDataURL(this.images[i]);
          }
        }
      }
    },

    removeImage(i) {
      this.images.splice(i, 1);
    },

    removeExistingImage(id) {
      this.existingImages.splice(id, 1);
    },

    getAssignmentDetail() {
      axios.get('assignment/detail/' + this.$route.params.id)
        .then((res) => {
          if (res.data) {
            this.assignmentData = res.data;
            this.hasAnswer = this.assignmentData.is_answered;
            if (this.assignmentData.img_paths) {
              this.existingImages = this.assignmentData.img_paths
            }
            this.getClass(this.assignmentData.acd_year_id);
            this.getTeacher(this.assignmentData.class_id);
            this.getSubject(this.assignmentData.teacher_id, this.assignmentData.class_id);
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getCurrentPeriodList() {
      axios.get('/period/getCurrentPeriodList', {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
      .then(res => {
        let $defaultSelectOption = [{
          'id': 0,
          'text': 'Select Academic Year'
        }];
        this.academicYearArr = $defaultSelectOption.concat(res.data);
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    getClass($yearId) {
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          if (this.classArr.length > 1) {
            this.noClassMsg = '';
          } else {
            this.noClassMsg = 'There is no class to show.';
          }
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getTeacher($class_id) {
      this.teacher_id = 0;
      this.subject_id = 0;
      axios.get('/teacher/getTeacherByClass/' + $class_id)
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Teacher'
          }];
          this.teacherArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getSubject($teacher_id, $class_id) {
      axios.get('/teacher/getSubjectByTeacher/' + $teacher_id + '/' + $class_id)
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Subject'
          }];
          this.subjectArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    update() {
      this.disabled = true;
      this.submitted = true;
      if (this.$v.$invalid || this.assignmentData.class_id == 0 || this.assignmentData.teacher_id == 0 || this.assignmentData.subject_id == 0) {
        this.disabled = false;
        return;
      }
      let formData = new FormData();

      // Merge the rest of assignmentData
      for (let key in this.updateAssignmentData) {
        if (key !== 'img_paths') {
          formData.append(key, this.assignmentData[key]);
        }
      }

      // Add Files with array 
      this.existingImages.forEach((file, index) => {
        formData.append(`img_paths[${index}][id]`, file.id); 
      });
      this.images.forEach((file) => {
        formData.append('new_images[]', file);
      });
      
      
      // Add campus_id and login_id
      formData.append('campus_id', this.$store.state.user.campus_id);
      formData.append('login_id', this.$store.state.user.id);

      axios.post(`assignment/update/${this.assignmentData.id}`, formData)
        .then(res => {
          if (res.data.original.success == true) {
            this.$notification.success("Assignment Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "assignmentList"
            });
          }
          this.disabled = false;
        }).catch(error => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 422) {
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter",
              });
            } else if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
          }
        });
    },

    changeClassEvent($class_id) {
      this.assignmentData.teacher_id = 0;
      this.assignmentData.subject_id = 0;
      this.getTeacher($class_id);
    },

    changeTeacherEvent($teacher_id, $class_id) {
      this.assignmentData.subject_id = 0;
      this.getSubject($teacher_id, $class_id);
    },

    changeAcademicYearEvent($acd_year_id) {
      this.assignmentData.class_id = 0;
      this.assignmentData.teacher_id = 0;
      this.assignmentData.subject_id = 0;
      this.getClass($acd_year_id);
    }
  },

  mounted() {
    this.isLoading = true;
    this.getCurrentPeriodList();
    this.getAssignmentDetail();
  },
}
